import React from 'react'
import {observer} from 'mobx-react-lite'
import {useBasketStore} from '../../../store/hooks/useStore'
import {useThresholds} from '../../../store/hooks/useThresholds'
import { BasketThresholdProgressBar } from './basket-threshold-progress-bar'

interface OrderSummaryProgressBarsProps {
  border: boolean
}

export const OrderSummaryProgressBars = observer(({border}: OrderSummaryProgressBarsProps) => {
  const {basket, currentDeliverySlotId} = useBasketStore()
  const {basketThresholds} = useThresholds()
  const customerHasBookedSlot = Boolean(currentDeliverySlotId)

  return (
    <>
      {basket ? basketThresholds.map((thresholdItem) => {
          return (
            <BasketThresholdProgressBar
              basketThreshold={thresholdItem}
              border={border}
            />
          )
      }) : null}
    </>
  )
})
